<template>
  <el-form label-width="auto" class="yourForm">
    <el-form-item label="小程序名称：">
      <el-input v-model="form.name" />
    </el-form-item>
    <el-form-item label="登录账号：">
      <el-input v-model="form.account" />
    </el-form-item>
    <el-form-item label="密码：">
      <el-input v-model="form.pwd" show-password />
    </el-form-item>
    <el-form-item label="负责人：">
      <el-input v-model="form.charge_person" />
    </el-form-item>
    <el-form-item label="联系电话：">
      <el-input v-model="form.telephone" />
    </el-form-item>
    <div v-if="id!==''" class="processingStatus">
      <div class="processing_label">处理状态:</div>
      <div class="processing_btn">
        <el-radio v-model="handle_status" label="1">未处理</el-radio>
        <el-radio v-model="handle_status" label="2">已处理</el-radio>
      </div>
    </div>
    <div class="getbtn">
      <el-button type="primary" @click="getbtn">提交</el-button>
    </div>

  </el-form>
</template>

<script>
import { updatawechat, addwechat, getwechatprogram } from '@/api/report/accountManagement'
export default {
  data() {
    return {
      // 收集表单数据
      form: {
        name: '',
        account: '',
        pwd: '',
        charge_person: '',
        telephone: ''
      },
      id: '',
      handle_status: ''
    }
  },

  created() {
  },

  methods: {
    edittwi(e) {
      //       name: this.form.name,
      // account: this.form.account,
      // pwd: this.form.email,
      // avatar: this.form.avatarKey,
      // introduce: this.form.introduce,
      // status: this.form.status
      this.id = e.id
      console.log('e', e.handle_status)
      this.form.name = e.name
      this.form.account = e.account
      this.form.pwd = e.pwd
      this.form.charge_person = e.charge_person
      this.form.telephone = e.telephone
      this.handle_status = String(e.handle_status)
    },
    add() {
      console.log('666')
      this.id = ''
      this.getdata()
    },
    getdata() {
      getwechatprogram().then(response => {
        this.form.charge_person = response.data.data.charge_person
        this.form.telephone = response.data.data.telephone
      }).catch(err => {
        console.log(err)
      })
    },
    getbtn() {
      if (this.id === '') {
        console.log('新增', this.form)

        addwechat(this.form).then(response => {
          console.log('response', response)
          this.$message({
            message: '添加成功',
            type: 'success'
          })
          this.qudiao()
          this.$emit('updata')
        }).catch(err => {
          console.log(err)
        })
      } else {
        updatawechat(this.id, {
          name: this.form.name,
          account: this.form.account,
          pwd: this.form.pwd,
          charge_person: this.form.charge_person,
          telephone: this.form.telephone,
          handle_status: Number(this.handle_status)
        }).then(response => {
          console.log('response', response)
          this.$message({
            message: this.$t('修改成功'),
            type: 'success'
          })
          this.qudiao()
          this.$emit('updata')
        })
        console.log('编辑', this.form, this.handle_status)
        // 编辑
      }
      // console.log('11')
    },
    qudiao() {
      this.form = {
        name: '',
        account: '',
        pwd: '',
        charge_person: '',
        telephone: ''
      }
      this.handle_status = ''
    }
  }
}
</script>

<style scoped>
 .yourForm .el-input {
    width: 350px;
  }
.processingStatus{
  display: flex;
  margin-left: 20px;
}
.processing_btn{
  margin-left: 20px;
}
.processing_label{
  font-size: 14px;
  color: #606266;
  font-weight: bold;
}
.getbtn{
  margin-left: 380px;
  margin-top: 20px;
}
</style>
